import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import AddIcon from "@material-ui/icons/Add";
import { isCurrentUserAdmin } from "../utils/userRoles";

const styles = theme => ({
  addNewButton: {
    textTransform: "none",
    marginLeft: theme.spacing(2)
  }
});

export const AddNewButton = withStyles(styles)(props => {
  const { onClick, title, classes } = props;
  if (isCurrentUserAdmin())
    return (
      <Button
        onClick={onClick}
        color="primary"
        variant="contained"
        className={classes.addNewButton}
        size="small"
      >
        <AddIcon />
        {title}
      </Button>
    );
  else return <div />;
});
